import React from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import $ from 'jquery';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import forgotpwdIcon from '../../images/icons/forgotpwdicon.png';

var fpServerResponses = {
      200: 'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',
      403: 'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',
      600: 'Invalid User ID or Email.', // also for 400, 401
      0: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'
    };

class ForgotPasswordForm extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
				username: '',
				email: '',     
				submitButtonDisabled: false,
				UseridEmailidSame:false,
				serverMessage: ""
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleemailChange = this.handleemailChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.submitLumosPwdForm = this.submitLumosPwdForm.bind(this);
		this.submitPLPPwdForm = this.submitPLPPwdForm.bind(this);
		this.renderUseridEmailidValue = this.renderUseridEmailidValue.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		
		this.myTrackerInstance = this.getTracker();
	}

	componentDidMount(){
		this.sessionCheck();
	} 
	
	handleForgotPwd(){
		
	}

	handleChange(e) {
		const target = e.currentTarget;	
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}

	handleemailChange(e) {    
		this.handleChange(e);
	}

	submitLumosPwdForm = function(){
		var me =this;	
		var formData = {
				"userId":this.state.username,
				"email":this.state.email
		}
		me.setState({submitButtonDisabled: true});
		$.ajax({
	            url: me.getUrlFor("LUMOS_FORGOTPWD"),
	            data: formData,
	            type: 'POST',
	            xhrFields: {
			       withCredentials: true
			    },
			    crossDomain: true,
	            success: function(response){	            	
	    			 switch (response.code) {
			             case 200:
			            	//me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.emailId)});
			            	me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g, me.state.email));
			            break;
			            case 403:
			            	me.setState({submitButtonDisabled: false, serverMessage: fpServerResponses[response.code].replace(/<email>/g, me.state.email)});
			            break;
			            case 400:
			            case 401:
			            case 600:		              
			            	me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600] });
			            break;
			            default:
			              //currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
			            	me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[0]});
			          }
	    			 
	    			 me.trackMe();
	    		},
	            error: function(response){
	    			console.log("Error in lumos login",response);
	    			me.setState({submitButtonDisabled: false});
	    			me.trackMe();
	    		}
	    });
		
	}
	
	trackMe(){		
		/*var trackObj = {
				"login_id":this.state.username,
				"email": this.state.email
		}

		this.initiateTrack("forgot_password",trackObj);*/
	}
	
	submitPLPPwdForm(){
		var userId = this.state.username;
		var emailId = this.state.email;
		
		if(this.state.UseridEmailidSame){
			userId = emailId
		}
		var formData = {
				"userId":userId,
				"emailId":emailId
		}

		var me =this;
		
		me.setState({submitButtonDisabled: true});
		
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status == "SUCCESS"){
					//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.emailId)});
					me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g, formData.emailId));
				}
				else if(response.status == "INVALID_EMAIL"){
					me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600]});
				}else if(response.status == "INVALID_USERID"){
					me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[600]});
				}else if(response.status == "PROVIDER_FORBIDDEN"){
					me.setState({ submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.pwd")});
				}
				else{
					me.setState({ submitButtonDisabled: false, serverMessage: fpServerResponses[0]});
				}
			}
			me.trackMe();
			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			me.setState({submitButtonDisabled: false});
			me.trackMe();
		}

		new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
	}
	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid(), serverMessage: "" });
		
		if (this.form.isValid()) {   

			if(this.props.source.toLowerCase() == "lumos"){
				this.submitLumosPwdForm();    
			}else{
				this.submitPLPPwdForm();
			}

		}
	}
	handleCheckboxChange(event){
		var target = event.target;		
		this.setState({"UseridEmailidSame":target.checked});
		if(event.target){
			this.setState({username:this.state.email})
		}
	}
	renderUseridEmailidValue(){
		if(this.state.UseridEmailidSame){			
			return this.state.email;
		}else{
			return this.state.username;
		}	
	}
	checkForDisabled(){
		if(this.state.UseridEmailidSame){
			return true;
		}else{
			return false;
		}
	}
	render() {
		
		if(this.state.loggedIn){
			return super.render();
		} else { return (
				<div className="row nomargin loginParent">
					<div className="col-sm-4 nopadding loginLeftSection">
						<h2 className="loginLeftContent">{this.rb("forgot_password_label")}</h2>
						<div className="charactercontainer d-none d-sm-block">
							<img className="charactericons forgotpwdIcon" src={forgotpwdIcon} />
						</div>
					</div>
					
					<div id="loginRoot" className="col-sm-8">
				
					<div className="container">
					
					<div>
						<div className="text-center schoolLoginInfo josefinsansFont nopadding">
							{this.rb("fpwd.msg1")}
							<br />
							{this.rb("fpwd.msg2")}
							<br />
							
							{(() => {
				 				if(this.props.source.toLowerCase() == "lumos"){
				 					return(
				 						<div className="text-center schoolLoginInfo josefinsansFont">
				 							{ReactHtmlParser(this.rb("fpwd.lumos.msg"))}
				 						</div>	
				 					);
				 				}										 				
				 			})()}
							
						</div>
					</div>
				
					<div className="row">
					<div className="col-md-12">
	
						<div className="row">
							<div className="col-md-12 nopadding">
								<div className="rounded-0">
									<div className="text-center">
									
										<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
										onSubmit={this.handleSubmit} noValidate>
										
											<FormGroup for="email">
												<FormControlInput type="email" className="email" name="email" placeholder={this.rb("fpwd.email")}
													innerRef={email => this.email = email}
												value={this.state.email} onChange={this.handleemailChange}				
												required maxLength={254} pattern="^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$" minLength={1} tabIndex="1"/>
												
												<FieldFeedbacks for="email" show="all">
													<FieldFeedback when="valueMissing">{this.rb("fpwd.emailrequired")}</FieldFeedback>
													<FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>					
												</FieldFeedbacks>					
											</FormGroup>
											
											<FormGroup for="username">
												<FormControlInput type="username" className="username" name="username" placeholder={this.rb("login.userid")}
													value={this.renderUseridEmailidValue()} onChange={this.handleChange} disabled={this.checkForDisabled()}
												required minLength={1} maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>
													<FieldFeedbacks for="username">
												<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
												<FieldFeedback when="*" />
													</FieldFeedbacks>
											</FormGroup>
											
											{(() => {
								 				if(this.props.source.toLowerCase() == "plp"){
								 					return(
								 							<div className="text-left">
									 							<label className="checkboxLabel">							 							
														          <input
														            className="fwdCheckbox"
														            name="sameUseridEmailid"
														            type="checkbox"												           
														            onChange={this.handleCheckboxChange} />
														          {this.rb("fpwd.plp.useridemailidsame")}
														        </label>
													        </div>
								 					);
								 				}										 				
								 			})()}
										
											<div className="forgotpwdMsg">
												<div className="server-messages"> {ReactHtmlParser(this.state.serverMessage)}</div>	
											</div>
											
											<button disabled={this.state.submitButtonDisabled} className="submitButton">{this.rb("login.send")}</button>										
										</FormWithConstraints>	
									</div>
								</div>
							</div>
						</div>
						
						{(() => {
			 				if(this.props.source.toLowerCase() == "plp"){
			 					return(
			 						<div className="text-center schoolLoginInfo josefinsansFont">
			 							{this.rb("fpwd.plp.note")}
			 						</div>	
			 					);
			 				}										 				
			 			})()}
						
						<br />
					</div>
					
					</div>
					</div>
					</div>
				</div>
		);}
	}
}

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./src/views/login/ForgotPasswordForm.js